module.exports = __webpack_public_path__ + "static/media/pen-arrow-icon.1d161ad8.svg";